import { Controller } from "@hotwired/stimulus"

import DisclosureItemController from "./disclosure_item_controller"

import Cookies from "@/helpers/cookies"
import { IS_PRODUCTION_OR_STAGING } from "@/helpers/environment"
import { pushGa4Event } from "@/helpers/ga4_helper"
import { debounce } from "@/helpers/utils"
import { isDesktop } from "@/helpers/window_size"

const CONSENT_COOKIE_NAME = "permConsent"
const EXPIRY = 365 // days

export default class extends Controller {
  static outlets = ["disclosure-item"]
  declare readonly disclosureItemOutlets: DisclosureItemController[]

  static targets = ["consentBanner"]
  declare readonly consentBannerTarget: HTMLElement

  declare readonly hasConsentBannerTarget: boolean

  initialize(): void {
    this.toggleNavLinks = debounce(this.toggleNavLinks.bind(this), 100)
  }

  connect(): void {
    if (this.hasConsentBannerTarget) {
      this.consentBannerTarget.hidden = this.isConsentSet
    }

    this.toggleNavLinks()
  }

  acceptConsent(): void {
    this.setConsent(true)
  }

  rejectConsent(): void {
    this.setConsent(false)
  }

  showConsentBanner(): void {
    if (this.hasConsentBannerTarget) {
      this.consentBannerTarget.hidden = false
    }
  }

  toggleNavLinks(): void {
    const isDesk = isDesktop()

    this.disclosureItemOutlets.forEach((disclosureItem) => {
      disclosureItem.openValue = isDesk
    })
  }

  private get isConsentSet(): boolean {
    return !!Cookies.get(CONSENT_COOKIE_NAME)
  }

  private setConsent(isConsentGiven: boolean): void {
    const value = isConsentGiven.toString()

    if (IS_PRODUCTION_OR_STAGING) {
      Cookies.set(CONSENT_COOKIE_NAME, value, { expires: EXPIRY, domain: "spabreaks.com" })
    } else {
      Cookies.set(CONSENT_COOKIE_NAME, value, { expires: EXPIRY })
    }

    pushGa4Event({ event: "set_gdpr_consent", consent_given: isConsentGiven })

    if (this.hasConsentBannerTarget) {
      this.consentBannerTarget.hidden = true
    }
  }
}
